import ShowMore from "../../showMore/showMore";

export default function PaginationMobileView({setPage}) {


    return (
        <>
        <ShowMore setPage={setPage}/>
        </>
    )
}